export default __webpack_public_path__ + "static/media/laptop2@3x.8b697011.png";